export const deleteCustomFormCheck = (customFormToDelete, pastCustomForm) => {
  const check = customFormToDelete && pastCustomForm?.length > 1;
  return check;
};
